export default "__VITE_ASSET__CNCK3Fh3__"